import { countries, employees, subscription, sortProductDropdown, sortDropdown } from './Dropdowns'

const InnoSalesUrl = 'https://innoage.in/InnoSales'
const InnoAge = 'InnoAge Technologies Pvt. Ltd.'
const GenericError = 'Some Error Occured. Please Try again later!!!'
const VerificationFailedForCaptch = "Verification Failed with Google's Re-Captcha. Please verify you are human"

const ExcelDownloadPath = 'https://innoage.blob.core.windows.net/public/Bulk_Upload_Sheet_Format.xlsx'

const InnoSalesLogo = 'https://innoageimages.blob.core.windows.net/images/assets/logo_color.svg'

const Activity = {
  notReviewed: 'Not Reviewed',
  queried: 'Queried',
  shortlisted: 'ShortListed',
  reviewed: 'Reviewed'
}

const availablePricing = [
  {
    id: 1,
    name: 'Freemium',
    price: '₹ 0',
    priceUnit: '/per year',
    description: 'Most Sutable for Startups that want digital Product Inventory',
    features: [
      'Free Forever for Startups',
      '1 User',
      '100 SKU',
      '1000 Pictures',
      '1 GB Space',
      'Company Shop',
      'Access to Help Portal'
    ]
  },
  {
    id: 2,
    name: 'Premium',
    price: '₹ 24999',
    priceUnit: '/per year',
    description: 'For Companies that want to Start Export Business with Digital Presence',
    features: [
      '3 Users',
      '500 SKUs',
      '5000 Pictures',
      '20 GB Space',
      'Company Shop',
      'Catalogue Generator',
      'PIS/PPT Downloads',
      '50 Catalogues',
      'Chat Box',
      'Access to Help Portal',
      '3 Day Training',
      'Onboarding Support & Demo'
    ]
  },
  {
    id: 3,
    name: 'Elite',
    price: '₹ 39999',
    priceUnit: '/per year',
    description: 'For Companies already in Export Business & want to grow further',
    features: [
      '7 Users',
      '2000 SKUs',
      '100000 Pictures',
      '100 GB Space',
      'Company Shop',
      'Dashboard',
      '1000 Catalogues',
      'Catalogue Generator',
      'Activity Tracker',
      'PIS/PPT Downloads',
      'Advance Image Editor',
      'Chat Box',
      'Access to Help Portal',
      '1 Week Training',
      'Live Onboarding & Demo',
      'Priority Support',
      'Branding Support'
    ]
  },
  {
    id: 4,
    name: 'Enterprise',
    price: 'Custom',
    priceUnit: ' (Tailored pricing)',
    description: 'For Large Enterprises that want to have everything on single Platform',
    isRecommended: true,
    features: [
      'Unlimited Users',
      'Unlimited SKUs',
      'Unlimited Pictures',
      '150 GB Space + Expansion Available',
      'Company Shop',
      'Dashboard',
      'Chat Box',
      'Quotation',
      'Unlimited Catalogues',
      'Catalogue Generator',
      'Activity Tracker',
      'PIS/PPT Downloads',
      'Advance Image Editor',
      'Bulk Import Products',
      'Bulk Edit Products',
      'Access to Help Portal',
      '1 Month Training',
      'Live Onboarding & Demo',
      'Priority Support',
      'Branding Support',
      'Access to Upcoming Features'
    ]
  }
]

const pptTemplateImages = [
  'https://res.cloudinary.com/innoage/image/upload/v1670397264/1_fcksd8.svg',
  'https://res.cloudinary.com/innoage/image/upload/v1670397263/2_xwnt8r.svg',
  'https://res.cloudinary.com/innoage/image/upload/v1670397263/3_aa01xh.svg',
  'https://res.cloudinary.com/innoage/image/upload/v1670397263/4_caj2go.svg',
  'https://res.cloudinary.com/innoage/image/upload/v1670397263/5_lku7vi.svg',
  'https://res.cloudinary.com/innoage/image/upload/v1670397263/6_u5lee7.svg'
]

const pptTemplate = [
  { image: 'https://res.cloudinary.com/innoage/image/upload/v1670397264/1_fcksd8.svg', productSize: 1, imageSize: 0 },
  { image: 'https://res.cloudinary.com/innoage/image/upload/v1670397263/2_xwnt8r.svg', productSize: 1, imageSize: 1 },
  { image: 'https://res.cloudinary.com/innoage/image/upload/v1670397263/3_aa01xh.svg', productSize: 1, imageSize: 2 },
  { image: 'https://res.cloudinary.com/innoage/image/upload/v1670397263/3_aa01xh.svg', productSize: 1, imageSize: 3 },
  { image: 'https://res.cloudinary.com/innoage/image/upload/v1670397263/3_aa01xh.svg', productSize: 1, imageSize: 4 },
  { image: 'https://res.cloudinary.com/innoage/image/upload/v1670397263/4_caj2go.svg', productSize: 2, imageSize: 1 },
  { image: 'https://res.cloudinary.com/innoage/image/upload/v1670397263/5_lku7vi.svg', productSize: 3, imageSize: 1 },
  { image: 'https://res.cloudinary.com/innoage/image/upload/v1670397263/6_u5lee7.svg', productSize: 4, imageSize: 1 }
]

const Constants = {
  InnoSalesUrl,
  InnoAge,
  GenericError,
  countries,
  employees,
  VerificationFailedForCaptch,
  ExcelDownloadPath,
  InnoSalesLogo,
  Activity,
  subscription,
  sortProductDropdown,
  sortDropdown,
  availablePricing,
  pptTemplateImages,
  pptTemplate
}

export default Constants
